module.exports = __webpack_public_path__ + "static/media/Sko-min.52d738c0.PNG";